export type NotificationType =
  | "new_order"
  | "branch_status"
  | "system"
  | "rating"
  | "debt";

export type NotificationFilter = "all" | "unread" | "orders" | "ratings" | "system";

export interface BranchNotification {
  id: string;
  type: NotificationType;
  title: string;
  message: string;
  time: string;
  read: boolean;
  /** رقم الطلب المرتبط (لفتح الطلب عند الضغط) */
  orderNumber?: number;
}

export const mockNotifications: BranchNotification[] = [
  {
    id: "n-101",
    type: "new_order",
    title: "طلب جديد #1236",
    message: "فيصل العمري — سفري · 30.80 ر.س",
    time: "منذ دقيقة",
    read: false,
    orderNumber: 1236,
  },
  {
    id: "n-102",
    type: "new_order",
    title: "طلب جديد #1234",
    message: "فهد العتيبي — سفري · 53.80 ر.س",
    time: "منذ 3 دقائق",
    read: false,
    orderNumber: 1234,
  },
  {
    id: "n-103",
    type: "new_order",
    title: "طلب جديد #1233",
    message: "نورة القحطاني — استلام من السيارة · 59.80 ر.س",
    time: "منذ 5 دقائق",
    read: false,
    orderNumber: 1233,
  },
  {
    id: "n-110",
    type: "debt",
    title: "تسجيل مديونية رسوم المنصة",
    message: "تم تسجيل 0.80 ر.س على المحل عند بدء تحضير الطلب #1231",
    time: "منذ 12 دقيقة",
    read: false,
    orderNumber: 1231,
  },
  {
    id: "n-104",
    type: "rating",
    title: "تقييم جديد ★ 5",
    message: "زبون محلي قيّم الطلب #1226 بخمس نجوم",
    time: "منذ 40 دقيقة",
    read: false,
    orderNumber: 1226,
  },
  {
    id: "n-105",
    type: "branch_status",
    title: "تنبيه — الفرع معلّق",
    message: "تم تعليق الفرع مؤقتًا من الإدارة، راجع الحالة",
    time: "اليوم 14:20",
    read: true,
  },
  {
    id: "n-106",
    type: "branch_status",
    title: "تم تفعيل الفرع",
    message: "عاد الفرع للعمل بشكل طبيعي، يمكنك استقبال الطلبات",
    time: "اليوم 13:45",
    read: true,
  },
  {
    id: "n-107",
    type: "system",
    title: "تحديث النظام",
    message: "تم تحديث التطبيق إلى الإصدار 2.4.0 مع تحسينات في الأداء",
    time: "أمس 18:10",
    read: true,
  },
  {
    id: "n-108",
    type: "rating",
    title: "تقييم جديد ★ 4",
    message: "عمر السبيعي قيّم الطلب #1225 بأربع نجوم",
    time: "أمس 12:05",
    read: true,
    orderNumber: 1225,
  },
  {
    id: "n-109",
    type: "system",
    title: "تذكير بنهاية اليوم",
    message: "لا تنسَ إغلاق الفرع وتسجيل الخروج عند انتهاء الوردية",
    time: "أمس 22:00",
    read: true,
  },
];